import React, { useEffect } from 'react';
import { MapContainer, ScaleControl, TileLayer, useMap } from 'react-leaflet';
import L from 'leaflet';
import 'leaflet/dist/leaflet.css';
import { notification } from 'antd';

import emprise from '../../assets/gis/emprise.json';
import stations from '../../assets/gis/stations.json';
import departements from '../../assets/gis/departements.json';
import meteoBasins from '../../assets/gis/meteo_basins.json';
import rivers from '../../assets/gis/hydrographic_network.json';
import isochrone96h from '../../assets/gis/isochrone96h.json';
import watershed from '../../assets/gis/bassins_versants_hydrographiques.json';
import pictoQ from '../../assets/images/picto-Q.png';
import station from '../../assets/images/station-limni.png';
import leau from '../../assets/images/leau.png';
import greyCircle from '../../assets/images/cercle.png';
import blueCircle from '../../assets/images/blue-circle.png';
import stationM from '../../assets/images/diffusion.png';
import { CompassControl } from './CompassControl';

const empriseStyle = {
  color: 'black',
  weight: 2,
  fillOpacity: 0,
};

const departementStyle = {
  color: 'black',
  weight: 1,
  dashArray: '4 4',
  fillOpacity: 0,
};

const stationTooltip = (feature) => ({
  content: `
    <div style="text-align: center;">
      <span style="font-weight: bold;">${feature.properties.station_code}<br></span>
      <span>(${feature.properties.station_name})</span>
    </div>
  `,
  options: {
    permanent: false,
    direction: 'top',
    className: 'station-tooltip',
  },
});

const createMarker = (feature, latlng, setSelectedStation, setSelectedNearestRain, selectedScenario, showCompareStation, setSelectedCompareStation, setData, compareChartData, setCompareData) => {
  const isTargetZero = feature.properties.target === 0;
  const isTrainable = feature.properties.trainable === 1;
  const isDSEA = feature.properties.measure_type === 'DSEA';
  const isP = feature.properties.measure_type === 'P';
  const isH = feature.properties.measure_type === 'H';
  const sizeTypeIcon = isDSEA ? [25, 28] : [22, 27];
  const sizeMStation = isP ? [18, 22] : [8, 8];
  const iconSize = isTargetZero ? sizeMStation : sizeTypeIcon;
  let marker;

  const classname = () => {
    if(isTargetZero) {
      if (isTrainable) {
        if(showCompareStation){
          return 'cursor-disabled';
        }
        return 'cursor-grab';
      }
      return 'cursor-disabled';
    }
    return 'cursor-context-menu';
  }

  const className = classname();


  const renderCircleIcon = () => {
    if(isTrainable) {
      if (isP) {
        return stationM;
      }
        return blueCircle;
    }
    if(!isTrainable) {
      return greyCircle;
    }
  }

  const renderMarkerType = (icon) => {
      const typeIcon = L.icon({
        iconUrl: isTargetZero ? renderCircleIcon(): icon,
        iconSize,
        className,
      })
      marker = L.marker(latlng, { icon: typeIcon })
      return marker;
    }

  if (isTargetZero && !isTrainable) {
    renderMarkerType(greyCircle); 
  }
  if (isTargetZero && isTrainable ) {
    renderMarkerType(blueCircle);
 }
  else if (isDSEA) {
    renderMarkerType(leau);
  }
  else if (isH) {
    renderMarkerType(station);
  }
  else {
    renderMarkerType(pictoQ);
  }

  const tooltip = stationTooltip(feature);
  marker?.bindTooltip(tooltip.content, tooltip.options).openTooltip();

  marker.on({
    mouseover: () => {
      marker.openTooltip();
    },
    click: () => {
        if(feature.properties.trainable === 1 && !showCompareStation) {
          setData([])
          setSelectedStation({
            name: feature.properties.station_name,
            code: feature.properties.station_code,
            bvName: feature.properties.bv_name,
            commune: feature.properties.com_name,
            dept: feature.properties.dep_code,
            deptName: feature.properties.dep_name,
            regName: feature.properties.reg_name,
            river: feature.properties.riv_name,
            target: feature.properties.target === 1
          })
        }
        setSelectedNearestRain(feature.properties.nearest_rain);
  
        if(isTargetZero && feature.properties.trainable === 1 && showCompareStation) {
          return null;
        }

        if (showCompareStation && feature.properties.trainable === 1) {
          setCompareData([])
          setSelectedCompareStation({
            name: feature.properties.station_name,
            code: feature.properties.station_code,
            bvName: feature.properties.bv_name,
            commune: feature.properties.com_name,
            dept: feature.properties.dep_code,
            deptName: feature.properties.dep_name,
            regName: feature.properties.reg_name,
            river: feature.properties.riv_name,
            target: feature.properties.target === 1
          });
        }

      if (!selectedScenario && feature.properties.target === 1) {
        notification.info({
          description: 'Veuillez sélectionner un scénario',
          duration: 2,
          placement: 'top',
        });
      }
    },
    mouseout: () => {
      marker.closeTooltip();
    },
    mousedown: (e) => {
      e.originalEvent.preventDefault();
    },
  });

  return marker;
};


const onEachMeteoBasins = (feature, layer) => {
  layer.on({
    mouseover: (e) => {
      const hoveredLayer = e.target;
      hoveredLayer.bindTooltip(
        `<div style="text-align: center; font-weight: bold;">
          Bassin méteo ${feature.properties.meteo_zone}
        </div>`,
        {
          permanent: false,
          direction: 'top',
          className: 'meteo-basin-tooltip',
        }
      ).openTooltip();
      hoveredLayer.setStyle({
        weight: 2,
        color: 'black',
      });
    },
    mouseout: (e) => {
      const hoveredLayer = e.target;
      hoveredLayer.closeTooltip();
      hoveredLayer.setStyle({
        color: 'transparent',
      });
    },
    mousedown: (e) => {
      e.originalEvent.preventDefault();
    },
  });
};
const onEachBV = (feature, layer) => {
  layer.on({
    mouseover: (e) => {
      const hoveredLayer = e.target;
      hoveredLayer.bindTooltip(
        `<div style="text-align: center; font-weight: bold;">
          Bassin méteo ${feature.properties.TopoOH}
        </div>`,
        {
          permanent: false,
          direction: 'top',
          className: 'meteo-basin-tooltip',
        }
      ).openTooltip();
      hoveredLayer.setStyle({
        weight: 2,
        color: '#87CEEB',
      });
    },
    mouseout: (e) => {
      const hoveredLayer = e.target;
      hoveredLayer.closeTooltip();
      hoveredLayer.setStyle({
        color: 'transparent',
      });
    },
    mousedown: (e) => {
      e.originalEvent.preventDefault();
    },
  });
};

const onEachDepartement = (feature, layer) => {
  layer.on({
    mouseover: (e) => {
      const layer = e.target;
      layer.setStyle({
        weight: 2,
        color: 'black',
      });
      layer.bindTooltip(feature.properties.insee_dep, {
        permanent: false,
        direction: 'center',
        className: 'departement-tooltip',
      }).openTooltip();
    },
    mouseout: (e) => {
      const layer = e.target;
      layer.setStyle(departementStyle);
      layer.closeTooltip();
    },
    mousedown: (e) => {
      e.originalEvent.preventDefault();
    },
  });
};

const DynamicLayers = ({
  showStations,
  showEmprise,
  selectedDepartments,
  showMeteoBasins,
  showRivers,
  showWatershed,
  setSelectedStation,
  setSelectedNearestRain,
  selectedScenario,
  showIsochrone,
  setData,
  selectedStation,
  selectedSearchStation,
  showCompareStation,
  setSelectedCompareStation,
  compareChartData,
  setCompareData
}) => {
  const map = useMap();

  useEffect(() => {
    if (selectedSearchStation) {
      setTimeout(() => {
        map.eachLayer((layer) => {
          if (layer.unbindTooltip) {
            layer.unbindTooltip();
          }
        });
        
        map.eachLayer((layer) => {
          if (layer.feature || (layer.getLayers && layer.getLayers().length > 0)) {
            if (layer.getLayers) {
              layer.getLayers().forEach(subLayer => {
                if (subLayer.feature?.properties?.station_code === selectedSearchStation) {
                  const tooltip = stationTooltip(subLayer.feature);
                  subLayer.bindTooltip(tooltip.content, tooltip.options).openTooltip();
                  
                  const lat = subLayer.feature.geometry.coordinates[1];
                  const lng = subLayer.feature.geometry.coordinates[0];
                  map.setView([lat, lng]);
                }
              });
            }
            else if (layer.feature?.properties?.station_code === selectedSearchStation) {
              const tooltip = stationTooltip(layer.feature);
              layer.bindTooltip(tooltip.content, tooltip.options).openTooltip();
              
              const lat = layer.feature.geometry.coordinates[1];
              const lng = layer.feature.geometry.coordinates[0];
              map.setView([lat, lng]);
            }
          }
        });
      }, 100);
    }
  }, [selectedSearchStation, map]);
  

  useEffect(() => {
    const layers = [];

    if (showEmprise) {
      const empriseLayer = L.geoJSON(emprise, { style: empriseStyle });
      layers.push(empriseLayer);
      empriseLayer.addTo(map);
    }

    if (showRivers) {
      const riversLayer = L.geoJSON(rivers, {
        style: (feature) => {
          const classe = feature.properties.Classe;
          let style;

          switch (classe) {
            case 1:
              style = {
                color: 'navy',
                weight: 2,
                opacity: 1,
              };
              break;
            case 2:
              style = {
                color: '#5d97e7',
                weight: 1.5,
                opacity: 1,
              };
              break;

            case 3:
              style = {
                color: '#5d97e7',
                weight: 1,
                opacity: 1,
              };
              break;
            default:
              style = {
                color: '#5d97e7',
                weight: 0.5,
              };
              break;
          }
          return style;
        },
      });
      layers.push(riversLayer);
      riversLayer.addTo(map);
    }

    if (showMeteoBasins) {
      const meteoBasinsLayer = L.geoJSON(meteoBasins, {
        style: (feature) => {
          const colors = ['#CDB4ED', '#b3cde3', '#ccebc5', '#decbe4', '#fed9a6', '#ffffcc', "#F1ABBD", '#e5d8bd', '#fddaec', '#f2f2f2'];
          const meteoZone = feature.properties.meteo_zone;
          const index = meteoZone % colors.length;
          return {
            fillColor: colors[index],
            fillOpacity: 0.6,
            color: 'transparent',
            weight: 1.3,
            opacity: 0.8,
          };
        },
        onEachFeature: onEachMeteoBasins,
      });
      layers.push(meteoBasinsLayer);
      meteoBasinsLayer.addTo(map);
    }

    if (showWatershed) {
      const watershedLayer = L.geoJSON(watershed, {
        style: (feature) => {
          const colors = ['#CDB4ED', '#b3cde3', '#ccebc5', '#decbe4', '#fed9a6', '#ffffcc', "#F1ABBD", '#e5d8bd', '#fddaec', '#f2f2f2'];
          const topo = feature.properties.TopoOH;
          const index = topo % colors.length;
          return {
            fillColor: colors[index],
            fillOpacity: 0.6,
            color: 'transparent',
            weight: 1.3,
            opacity: 0.8,
          };
        },
        onEachFeature: onEachBV,
      });
      layers.push(watershedLayer);
      watershedLayer.addTo(map);
    }

    if (showIsochrone) {
      const isochroneLayer = L.geoJSON(isochrone96h);
      layers.push(isochroneLayer);
      isochroneLayer.addTo(map);
    }

    if (selectedDepartments) {
      const filteredDepartements = {
        ...departements,
        features: departements.features.filter((feature) =>
          selectedDepartments.includes(feature.properties.insee_dep)
        ),
      };

      const departementsLayer = L.geoJSON(filteredDepartements, {
        style: departementStyle,
        onEachFeature: onEachDepartement,
      });
      layers.push(departementsLayer);
      departementsLayer.addTo(map);
    }

    if (showStations) {
      const stationsLayer = L.geoJSON(stations, {
        pointToLayer: (feature, latlng) =>
          createMarker(
            feature,
            latlng,
            setSelectedStation,
            setSelectedNearestRain,
            selectedScenario,
            showCompareStation,
            setSelectedCompareStation,
            setData,
            compareChartData,
            setCompareData,
          ),
      });
      layers.push(stationsLayer);
      stationsLayer.addTo(map);
    }

    return () => {
      layers.forEach((layer) => map.removeLayer(layer));
    };
  }, [
    map,
    showStations,
    showEmprise,
    selectedDepartments,
    showMeteoBasins,
    showRivers,
    showWatershed,
    selectedStation,
    selectedScenario,
    showIsochrone,
    showCompareStation,
    compareChartData,
  ]);
  return null;
};

const MapLeak = ({
  showStations,
  showEmprise,
  selectedDepartments,
  showMeteoBasins,
  showRivers,
  showWatershed,
  showIsochrone,
  selectedStation,
  setSelectedStation,
  setSelectedNearestRain,
  selectedScenario,
  setOpenDrawer,
  selectedSearchStation,
  showCompareStation,
  setSelectedCompareStation,
  setData,
  compareChartData,
  setCompareData
}) => {
  const position = [48.15, 3.7833];

  return (
    <MapContainer className="leaflet-container" center={position} zoom={9}>
      <CompassControl />
      <ScaleControl position="topleft" />
      <TileLayer
        attribution='&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors'
        url="https://server.arcgisonline.com/ArcGIS/rest/services/World_Topo_Map/MapServer/tile/{z}/{y}/{x}"
      />
      <DynamicLayers
        showStations={showStations}
        showEmprise={showEmprise}
        selectedDepartments={selectedDepartments}
        showMeteoBasins={showMeteoBasins}
        showRivers={showRivers}
        showIsochrone={showIsochrone}
        showWatershed={showWatershed}
        setSelectedStation={setSelectedStation}
        setSelectedNearestRain={setSelectedNearestRain}
        selectedScenario={selectedScenario}
        setOpenDrawer={setOpenDrawer}
        selectedStation={selectedStation}
        selectedSearchStation={selectedSearchStation}
        showCompareStation={showCompareStation}
        setSelectedCompareStation={setSelectedCompareStation}
        compareChartData={compareChartData}
        setData={setData}
        setCompareData={setCompareData}
      />
    </MapContainer>
  );
};

export default MapLeak;
